import { CommonService } from "src/app/core/services/common.service";
import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { Subscription } from "rxjs";
import { SuiteService } from "src/app/core/services/suite.service";
import { AnalyticService } from "src/app/core/services/analytics.service";

/**
 * Sidebar Component
 */
@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SidebarComponent implements OnInit, OnChanges, OnDestroy {
  sidebarServiceValue: boolean;
  accordionClose: any;
  accordionActive: any;
  tooltipDisable: any;
  accordionMenu1: boolean;
  accordionMenu2: boolean;
  accordionMenu3: boolean;
  accordionMenu4: boolean;
  showLoading: boolean = false;
  hamburgerSidenavMenu = false;
  analyticsPowerBiReports: any[];
  displayAllAnalyticsTile: boolean = false;
  menuPowerBiReports: any[];

  /**
   * Router Subscription
   */
  router_sub: Subscription;

  /**
   * Menu Url
   */
  menuUrl: string;

  /**
   * Suite url
   */
  suite: string;

  /**
   * Sub report url
   */
  subreports: string;

  constructor(
    private router: Router,
    private suiteService: SuiteService,
    private sidebarShared: CommonService,
    private analyticService: AnalyticService
  ) {
    this.menuUrl = router.url;
    this.router_sub = router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((val) => {
      if (val.url !== undefined) {
        this.menuUrl = val.url;
        const splitUrl = this.menuUrl.split("/");
        if (splitUrl.length && splitUrl.length > 2 && splitUrl[1] === "suite") {
          this.suite = this.suiteService.getCurrentSuite();
        } else {
          this.suite = this.suiteService.getLatestSuite();
        }

        if (
          splitUrl.length &&
          splitUrl.length === 5 &&
          splitUrl[4] != "subreports" &&
          splitUrl[1] === "suite"
        ) {
          this.subreports = splitUrl[3].toString();
        } else {
          this.subreports = "";
        }
      }
      });
  }

  ngOnInit() {
    this.accordionActive = null; // No accordion open initially
    this.tooltipDisable = true;
    this.accordionClose = true;

    this.sidebarShared.watchShowPanel().subscribe((data) => {
      //Denotes sidebar toggle is true (small width)
      if (data == true) {
        this.accordionClose = false;
        this.accordionActive = null; // Close all accordions when sidebar is collapsed
        this.tooltipDisable = false;
      }
      //Denotes sidebar toggle is false (normal width)
      else {
        this.accordionClose = true;
        this.accordionActive = null; // Close all accordions when sidebar expands
        this.tooltipDisable = true;
      }
    });

    this.accordionActiveCheck();
    this.getPowerBiReports();
  }

  getPowerBiReports() {
    this.showLoading = true;
    this.analyticService.GetPowerBiAnalyticsReport().then(
      () => {
        // filtering the reports based on show in menu flag
        this.analyticsPowerBiReports = this.analyticService.analyticsReports;
        if (
          this.analyticsPowerBiReports.find((item) => item.ShowInMenu == false)
        ) {
          this.displayAllAnalyticsTile = true;
        }
        this.menuPowerBiReports = this.analyticsPowerBiReports.filter(
          (item) => item.ShowInMenu == true
        );
        this.showLoading = false;
      },
      () => {
        this.showLoading = false;
      }
    );
  }

  ngOnDestroy() {
    if (this.router_sub) {
      this.router_sub.unsubscribe();
    }
  }

  ngOnChanges() {}

  accordionActiveCheck() {
    if (
      this.router.url.includes("task-board") ||
      this.router.url.includes("suite") ||
      this.router.url.includes("reportpack-dashboard")
    ) {
      this.accordionActive = 0;
    } else if (
      this.router.url.includes("data-ingestion") ||
      this.router.url.includes("bulk-report-run") ||
      this.router.url.includes("report-bundling")
    ) {
      this.accordionActive = 1;
    } else if (
      this.router.url.includes("user-management") ||
      this.router.url.includes("role-management") ||
      this.router.url.includes("reportpack-management") ||
      this.router.url.includes("report-schedule-management") ||
      this.router.url.includes("permission-management") ||
      this.router.url.includes("bundle-type-management") ||
      this.router.url.includes("report-pack-sequence-management") ||
      this.router.url.includes("application-configuration")
    ) {
      this.accordionActive = 2;
    } else if (this.router.url.includes("all-analytics") || this.router.url.includes("analytics-report-dashboard")) {
      this.accordionActive = 3;
    } else if (
      this.router.url.includes("client-management") ||
      this.router.url.includes("report-downloader") ||
      this.router.url.includes("query-engine") ||
      this.router.url.includes("ref-data") ||
      this.router.url.includes("mask-report-pack")
    ) {
      this.accordionActive = 4;
    } else {
      this.accordionActive = null; // No accordion open
    }
  }

  showHamburgerSidenav() {
    this.hamburgerSidenavMenu = true;
  }

  closeHamburgerSidenav() {
    this.hamburgerSidenavMenu = false;
  }
}
